import { useState } from 'react';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/transitional/components/View';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { SafeHTML } from 'integrations-lib/components/SafeHTML';
import { getOptions } from './utils/getOptions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AuthorizationStatusView = ({
  accountStatusesList = [],
  alertStore,
  error,
  loading = false,
  onAuthSucceeded,
  showInstalledStatus,
  showTooltip = true,
  tracker
}) => {
  /** When the value is `undefined` then Tooltip is controlled by its inner state */
  const [tooltipOpen, setTooltipOpen] = useState();
  const {
    tooltipDisabled,
    tooltipHeadingText,
    tooltipMessage,
    content,
    ctaButton
  } = getOptions({
    accountStatusesList,
    alertStore,
    loading,
    setTooltipOpen,
    showInstalledStatus,
    onAuthSucceeded,
    tracker
  });
  if (error || !content) {
    return null;
  }
  return /*#__PURE__*/_jsx(TFlex, {
    align: "center",
    minBlockSize: "36px",
    children: loading ? /*#__PURE__*/_jsx(LoadingSpinner, {
      showResult: false,
      grow: false,
      size: "xs",
      layout: "centered",
      minInlineSize: "100px"
    }) : /*#__PURE__*/_jsx(Tooltip, {
      open: tooltipOpen,
      disabled: !showTooltip || tooltipDisabled,
      use: "longform",
      headingText: tooltipHeadingText,
      title: /*#__PURE__*/_jsxs(View, {
        children: [!!tooltipMessage && /*#__PURE__*/_jsx(View, {
          display: "block",
          children: /*#__PURE__*/_jsx(SafeHTML, {
            html: tooltipMessage
          })
        }), ctaButton]
      }),
      children: /*#__PURE__*/_jsx(TFlex, {
        align: "center",
        children: content
      })
    })
  });
};